import React from 'react';

import { DropdownWrapper } from '../../../ui/dropdownwrapper/DropdownWrapper';
import Iconify from '../../../../layouts/components/iconify/iconify';

const StatusSelect = ({
    statusList = [],
    selectedStatus,
    selectedStatusName,
    selectedStatusClassName,
    onChange,
    allowEditStatus,
}) => {
    const defaultStatus =
        statusList.length && selectedStatus != null && selectedStatus !== ""
            ? statusList.find((item) => String(item.value) === String(selectedStatus))
            : null;

    const generateStatusClass = (status) => {
        if (!status) return;
        let statusValue = status.toLowerCase().split(" ").join("");
        return statusValue;
    }

    const fallbackClassSource = selectedStatusClassName || selectedStatusName;
    const statusClass = defaultStatus?.className
        ? generateStatusClass(defaultStatus.className)
        : fallbackClassSource
            ? generateStatusClass(fallbackClassSource)
            : 'default';
    const statusLabel = defaultStatus?.label
        ? defaultStatus.label
        : (selectedStatusName || 'Select');

    const statusChip = (
        <div
            className={`taskgrid-status-dropdown ${statusClass}${allowEditStatus ? ' is-editable' : ''}`}
            title={statusLabel}
        >
            <span className="taskgrid-status-label">{statusLabel}</span>
            {allowEditStatus && (
                <Iconify icon="bitcoin-icons:caret-down-filled" width={12} />
            )}
        </div>
    );

    if (!allowEditStatus) {
        return statusChip;
    }

    return (
        <DropdownWrapper
            closeOnSelect={true}
            matchToggleWidth={true}
            className="taskgrid-chip-menu-popup"
            toggleElement={statusChip}
        >
            <div className="taskgrid-chip-menu">
                {statusList.length && statusList.map((status) => (
                    <button
                        type="button"
                        key={status.value}
                        className="taskgrid-chip-menu-item"
                        onClick={() => onChange(status)}
                    >
                        <span className={`taskgrid-status-dropdown ${generateStatusClass(status.className)}`}>
                            <span className="taskgrid-status-label">{status.label}</span>
                        </span>
                    </button>
                ))}
            </div>
        </DropdownWrapper>
    )
}

export default StatusSelect
